import PropTypes from "prop-types";
import PoktoolsState from "./PoktoolsState";

const POKTOOLS_ACTIONS = {
  UPDATE_TOKEN: "UPDATE_TOKEN",
  TOKEN_UPDATED: "TOKEN_UPDATED",
  USER_UPDATED: "USER_UPDATED",
  LICENCE_UPDATED: "LICENCE_UPDATED"
};

function poktoolsReducer(state, action) {
  switch (action.type) {
    case POKTOOLS_ACTIONS.TOKEN_UPDATED: {
      let _state = PoktoolsState.from(state);
      _state.xPassPoktools = action.payload;
      return _state;
    }
    case POKTOOLS_ACTIONS.USER_UPDATED: {
      let _state = PoktoolsState.from(state);
      _state.xUserPoktools = action.payload;
      return _state;
    }
    case POKTOOLS_ACTIONS.LICENCE_UPDATED: {
      let _state = PoktoolsState.from(state);
      _state.xXeesterLicence = action.payload.licence;
      _state.licenseDate = action.payload.licenseDate;
      _state.remainingTime = action.payload.remainingTime;
      //console.log("state", _state);
      return _state;
    }
    default:
      return state;
  }
}
poktoolsReducer.propTypes = {
  state: PropTypes.instanceOf(PoktoolsState).isRequired,
  action: PropTypes.string.isRequired
};

export { POKTOOLS_ACTIONS, poktoolsReducer };
